import { Accordion, AccordionContent, AccordionHeader, AccordionItem, GridColumn } from 'telia-front-react';
import React, { Component } from 'react';
import { createGaEvent } from '../util/GaUtil';
import PersonalDataTabs from './PersonalDataTabs';
import PersonInfoHeader from './PersonInfoHeader';
export default class PersonWrapper extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onPersonalDataAccordionToggle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                createGaEvent({
                    eventCategory: 'Iseteenindus - Konto',
                    eventAction: 'Isikuandmed',
                    eventLabel: 'person-data-accordion'
                });
            }
        });
    }
    render() {
        return (React.createElement(GridColumn, { width: ['xs-12'] },
            React.createElement(Accordion, { defaultOpenItem: this.shouldOpenPersonalDataAccordion() ? ['person-data-accordion'] : [], onToggle: this.onPersonalDataAccordionToggle },
                React.createElement(AccordionItem, { id: "person-data-accordion" },
                    React.createElement(AccordionHeader, null,
                        React.createElement(PersonInfoHeader, null)),
                    React.createElement(AccordionContent, null,
                        React.createElement(PersonalDataTabs, null))))));
    }
    shouldOpenPersonalDataAccordion() {
        return (window.location.hash && window.location.hash.endsWith('sign-in-methods-tab')) || window.location.hash.endsWith('customer-service-password-tab');
    }
}
